export default "__VITE_ASSET__DxE9TFYK__"